var _rect, _rect2, _rect3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 779,
    height: 780,
    viewBox: "0 0 779 780",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 325.712,
    y: 14.649,
    width: 127.754,
    height: 750.728,
    rx: 63.8769,
    fill: "#575757"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.531006,
    y: 91.2907,
    width: 127.754,
    height: 514.092,
    rx: 63.8769,
    transform: "rotate(-45 0.531006 91.2907)",
    fill: "#575757"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 127.754,
    height: 514.092,
    rx: 63.8769,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 454.384 415.553)",
    fill: "#575757"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M733.479 136.459C758.424 111.513 758.424 71.0684 733.479 46.1229C708.533 21.1774 668.089 21.1774 643.143 46.1229L298.778 390.488L389.113 480.824L733.479 136.459Z",
    fill: "#3CB501"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M733.479 644.497C758.424 669.442 758.424 709.887 733.479 734.832C708.533 759.778 668.089 759.778 643.143 734.832L339.891 431.581L430.227 341.245L733.479 644.497Z",
    fill: "#3CB501"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logoMobile.448dfc4b1a1630b6dc3ceeaaccd1dfbb.svg";
export { ForwardRef as ReactComponent };